module.exports = __webpack_public_path__ + "img/2.4b7596b9.jpg";